import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { RootState } from '../../../../store/root-reducer';

import Sidebar from './sidebar';

import { UnreadEmailThreadsCountPayload } from '../../types';
import {
  getUnreadEmailThreadsCountRequest,
  updateUserSettingsRequest,
} from '../../extra-actions';
import {
  updateApplicationState,
  updateShowSidebarValue,
} from '../../home-slice';
import { UpdateUserSettingsRequestPayload } from '../../../sequence/types';

const mapStateToProps = (state: RootState) => ({
  agencyConfig: state.home.agencyConfig,
  agencyConfigRequestStatus: state.home.getAgencyConfigRequest.status,

  getUserSettingsRequestStatus: state.home.getUserSettingsRequest.status,

  planCode: state.home.subscription?.planCode,

  unreadEmailThreadsCount: state.home.unreadEmailThreadsCount,

  hasVisitedAgencyPortal: state.home.application.hasVisitedAgencyPortal,
  client: state.home?.client,
  isAgency: parseInt(state.home.isAgency, 10),
  hasDomains: state.home.hasDomains,
  hasDedicatedIps: state.home.hasDedicatedIps,

  isMultichannelActive: state.home.isMultichannelActive,
  isDemoAccount: state.home.isDemoAccount,
  meta: state.home.meta,
  leadFinder: state.home.leadFinder,
});

const mapDispatchToProps = {
  sendGetUnreadEmailThreadsCountRequest: (
    payload: UnreadEmailThreadsCountPayload,
  ) => getUnreadEmailThreadsCountRequest(payload),
  handleHasVisitedAgencyPortal: (hasVisitedAgencyPortal: boolean) =>
    updateApplicationState({ hasVisitedAgencyPortal }),
  sendShowSidebarRequest: (payload: UpdateUserSettingsRequestPayload) =>
    updateUserSettingsRequest(payload),
  updateShowSidebarValue: () => updateShowSidebarValue(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & RouteComponentProps;

export default withRouter(connector(Sidebar));
